import { render, staticRenderFns } from "./SaleSelectInputWidget.vue?vue&type=template&id=d937bfba&scoped=true"
import script from "./SaleSelectInputWidget.vue?vue&type=script&lang=js"
export * from "./SaleSelectInputWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d937bfba",
  null
  
)

export default component.exports